import {
  ALTAPROTOCOLOPCR_ERROR,
  ALTAPROTOCOLOPCR_LOADING,
  ALTAPROTOCOLOPCR_SUCCESS,
  ALTAPROTOCOLOPCR_RESET,
  RESET_PORTAL_CONTEXT,

} from "../ActionTypes";

import altaProtocoloPcrInitialState from "../initialStates/altaProtocoloPcrInitialState";

const altaProtocoloPcr = (state, { payload, type }) => {
  switch (type) {
    case ALTAPROTOCOLOPCR_LOADING:
      return {
        ...state,
        altaProtocoloPcr: {
          ...state.altaProtocoloPcr,
          error: false,
          loading: true,
        },
      };
    case ALTAPROTOCOLOPCR_SUCCESS:
      return {
        ...state,
        altaProtocoloPcr: {
          ...state.altaProtocoloPcr,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case ALTAPROTOCOLOPCR_ERROR:
      return {
        ...state,
        altaProtocoloPcr: {
          ...state.altaProtocoloPcr,
          error: payload,
          loading: false,
        },
      };
    case ALTAPROTOCOLOPCR_RESET:
      return altaProtocoloPcrInitialState;
    case RESET_PORTAL_CONTEXT:
      return altaProtocoloPcrInitialState;

    default:
      return state;
  }
};

export default altaProtocoloPcr;
